import gql from 'graphql-tag';

export default gql`
	mutation ProfileType($id: ID, $profileType: Int) {
		profileType(id: $id, profileType: $profileType) {
			id
		}
	}
`;



// WEBPACK FOOTER //
// ./src/mutations/profileType.js